<template>
  <div id="contenedor-editar-funcionario">
    <v-form v-model="esFormularioValido" ref="editarFuncionario">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Funcionario
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre del Funcionario"
            v-model="funcionario.nombre"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarFuncionario"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Puesto"
            v-model="funcionario.puesto"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarFuncionario"
            required
          >
          </custom-text-field>
          <v-row>
            <v-col cols="12" lg="6">
              <custom-date-picker
                v-model="funcionario.fechaNombramiento"
                :rules="[mixReglas.requerido]"
                label="Fecha de Nombramiento"
              >
              </custom-date-picker>
            </v-col>
            <v-col>
              <v-switch
                v-model="funcionario.esSupervisor"
                label="¿Es Supervisor?"
                inset
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarFuncionario"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoFuncionarios from './mixCatalogoFuncionarios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosFuncionariosEditar',
  mixins: [mixCatalogoFuncionarios],
  props: {
    funcionarioEditar: Object,
  },
  components: {
    CustomTextField,
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      funcionario: {
        nombre: this.funcionarioEditar.nombre,
        puesto: this.funcionarioEditar.puesto,
        fechaNombramiento: this.funcionarioEditar.fechaNombramiento,
        esSupervisor: this.funcionarioEditar.esSupervisor,
      },
      date: '',
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarFuncionario.reset();
      this.funcionario.esSupervisor = false;
    },
  },
};
</script>

<style lang="scss">
</style>
